import { api } from "./client";

export interface AuditHealth {
  services: {
    "darknet-monitor": "active" | "inactive" | "failed";
    "darknet-worker": "active" | "inactive" | "failed";
  };
  queues: {
    jobs_tor: number;
    jobs_tor_high: number;
  };
  forums: {
    forum: string;
    status: "success" | "failed";
    last_run_at: string | null;
    urls_found: number;
    errors: number;
  }[];
  stats: {
    total_forums: number;
    failing_forums: number;
    succeeding_forums: number;
    last_successful_run_at: string | null;
  };
}

export interface MonitoringRun {
  id: string;
  forum: string;
  run_started_at: string | null;
  run_finished_at: string | null;
  urls_found: number;
  new_urls: number;
  errors: number;
  status: "success" | "failed";
}

export interface MonitoringRunsResponse {
  items: MonitoringRun[];
  total: number;
  page: number;
  pages: number;
}

export interface LogLine {
  timestamp: string | null;
  level: string;
  logger: string | null;
  message: string;
  raw: string;
}

export const fetchAuditHealth = async (): Promise<AuditHealth> => {
  const res = await api.get("/admin/audit/health");
  return res.data;
};

export const fetchAuditRuns = async (params?: {
  forum?: string;
  status?: string;
  limit?: number;
  page?: number;
  before?: string;
  after?: string;
}): Promise<MonitoringRunsResponse> => {
  const res = await api.get("/admin/audit/runs", { params });
  return res.data;
};

export const fetchAuditLogs = async (params: {
  file: "app" | "monitor-error" | "worker-error";
  lines?: number;
  level?: string;
  search?: string;
}): Promise<LogLine[]> => {
  const res = await api.get("/admin/audit/logs", { params });
  return res.data;
};
